<template>
  <div id="app">
    <SopaDeLetras />
  </div>
</template>

<script>
import SopaDeLetras from '@/components/SopaDeLetras.vue'
export default {
  name: 'app',
  components: {
    SopaDeLetras
  }
}
</script>

<style>

</style>
